import { render, staticRenderFns } from "./PlusHeaderReports.vue?vue&type=template&id=c950d090"
import script from "./PlusHeaderReports.vue?vue&type=script&lang=js"
export * from "./PlusHeaderReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports